import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
// Import required modules
import { Navigation, Autoplay } from "swiper/modules";
import ScrollReveal from "./ScrollReveal";

const StayUpdated = () => {
  const navigate = useNavigate();
  // Ref to control the progress circle animation directly
  const progressCircle = useRef(null);

  // Function to animate the SVG circle based on autoplay time
  const onAutoplayTimeLeft = (s, time, progress) => {
    if (progressCircle.current) {
      progressCircle.current.style.setProperty("--progress", 1 - progress);
    }
  };

  const resources = [
    {
      id: 13,
      category: "WHITE PAPER",
      slug: "agentic-ai-digital-workforce-security",

      title:
        "Agentic AI: The New Digital Workforce and the Future of Enterprise Security",

      description:
        "Autonomous AI agents are rapidly becoming part of enterprise operations, introducing new security, identity, governance, and compliance challenges that traditional security models were never designed to address.",

      cta: "Download White Paper",

      boxColor: "bg-gray-900",

      titleColor: "text-white",

      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/v1781886444/_a50667a2-674f-4f4c-89dd-5f1bf828cbf0_ayroci.jpg",

      imageRotation: "rotate-1",

      hoverRotation: "group-hover:rotate-3",
    },
    {
      id: 1,
      category: "WHITEPAPER",
      slug: "ciso-ai-security-checklist",
      title:
        "The Shadow AI Crisis: Why Enterprises Are Losing Control of AI Usage",
      description:
        "This whitepaper explores how employees are using unauthorized AI tools, exposing sensitive data and bypassing security frameworks.",
      cta: "Download Checklist",
      boxColor: "bg-[#b8ccc6]",
      titleColor: "text-gray-900",
      // ADD YOUR IMAGE URLS HERE
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/v1782404940/add_this_Agentic_AI_The_New_Digital_Workforce_and_the_Future_ox2srg.jpg",
      imageRotation: "rotate-3",
      hoverRotation: "group-hover:rotate-6",
    },
    {
      id: 2,
      category: "BLOGS",
      slug: "securing-agentic-ai", // Updated to match your new blog slug
      title: "Securing Agentic AI: Visibility & Guardrails",
      description:
        "Enterprises are deploying AI agents to execute actions autonomously. Learn why the 'blast radius' of Agentic AI requires a fundamentally new approach to security.",
      cta: "Read Article",
      boxColor: "bg-[#0e7a5c]",
      titleColor: "text-white",
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1775996112/Secure-Autonomous-Agentic-AI-1200x794-1-1024x678.png_lh82ez.webp",
      imageRotation: "-rotate-2",
      hoverRotation: "group-hover:-rotate-6",
    },
    {
      id: 3,
      category: "WHITE PAPER",
      slug: "unified-threat-protection",
      title:
        "Unified Threat Protection: From Fragmented Silos to an Integrated Defense Architecture",
      description:
        "Fragmented security tools create critical blind spots attackers exploit. Learn how Unified Threat Protection eliminates contextual gaps and enables real-time, automated threat response across identity, endpoint, network, and data layers.",
      cta: "Download White Paper",
      boxColor: "bg-gray-900",
      titleColor: "text-white",
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776007788/3D_Booklet_Mockup_for_Synthera_Security_nyksnc.png",
      imageRotation: "rotate-1",
      hoverRotation: "group-hover:rotate-3",
    },
    {
      id: 4,
      category: "BLOGS",
      slug: "what-is-privileged-access-management-pam", // Updated to match your new blog slug
      title: "What Is Privileged Access Management (PAM)?",
      description:
        "Privileged access management (PAM) is the control and protection of elevated access rights for privileged accounts to help reduce the risk of data breaches.",
      cta: "Read Article",
      boxColor: "bg-[#0e7a5c]",
      titleColor: "text-white",
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1780572932/pam_nsczjo.png", // Intentionally left blank as requested for this specific blog
      imageRotation: "-rotate-2",
      hoverRotation: "group-hover:-rotate-6",
    },
    {
      id: 5,
      category: "WHITE PAPER",
      slug: "autonomous-ai-agents-security",
      title:
        "The Rise of Autonomous AI Agents: Security Risks No One Is Talking About",
      description:
        "Autonomous AI agents are transforming enterprises—but introducing hidden security risks. Discover how agent-driven actions, API access, and uncontrolled workflows create new attack surfaces that traditional security cannot detect.",
      cta: "Download White Paper",
      boxColor: "bg-gray-900",
      titleColor: "text-white",
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776061830/Synthera_Security_Booklet_Mockup_1_esxdte.png",
      imageRotation: "rotate-1",
      hoverRotation: "group-hover:rotate-3",
    },
    {
      id: 6,
      category: "WHITE PAPER",
      slug: "ai-governance-blueprint-enterprise",
      title: "AI Governance Blueprint for the Enterprise",
      description:
        "As AI adoption accelerates, enterprises need structured governance to manage risk, compliance, and control. Learn how to build a scalable framework that ensures secure and responsible AI usage across the organization.",
      cta: "Download White Paper",
      boxColor: "bg-gray-900",
      titleColor: "text-white",
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1776092120/Elegant_Cybersecurity_Booklet_Display_cosxez.png",
      imageRotation: "rotate-1",
      hoverRotation: "group-hover:rotate-3",
    },
    {
      id: 7,
      category: "BLOGS",
      slug: "vercel-breach-ai", // Updated to match your new blog slug
      title:
        "When Trust Becomes the Attack Surface: Lessons from the Vercel Breach in the Age of AI",
      description:
        "This blog explores the Vercel breach, the anatomy of an identity pivot, and why traditional SASE isn't enough to stop AI-accelerated threats.",
      cta: "Read Article",
      boxColor: "bg-[#0e7a5c]",
      titleColor: "text-white",
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/f_auto,q_auto,w_1200/v1777029083/Gemini_Generated_Image_ay9ff0ay9ff0ay9f_qcjtgq.png",
      imageRotation: "-rotate-2",
      hoverRotation: "group-hover:-rotate-6",
    },
    // {
    //   id: 8,
    //   category: "REPORT",
    //   slug: "total-economic-impact",
    //   title: "Total Economic Impact™ of Synthera SASE Cloud",
    //   description:
    //     "In this webinar, we will discuss in detail a 'Total Economic Impact' study conducted by Forrester Consulting on behalf of Synthera Networks.",
    //   cta: "Read Now",
    //   boxColor: "bg-white border border-gray-200",
    //   titleColor: "text-gray-900",
    //   coverImage:
    //     "https://res.cloudinary.com/dpn3bkjba/image/upload/v1766817415/Cato-MQ-630x400-1.png_yvejih.webp",
    //   imageRotation: "rotate-0",
    //   hoverRotation: "group-hover:rotate-2",
    // },
    {
      id: 9,
      category: "WHITE PAPER",
      slug: "sase-ai-control-plane",
      title: "SASE in the Age of Artificial Intelligence",
      description:
        "This explores how organizations can reduce complexity, lower costs, and strengthen security by adopting a unified SASE architecture for AI-driven environments.",
      cta: "Download White Paper",
      boxColor: "bg-white border border-gray-200",
      titleColor: "text-gray-900",
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/v1777308368/_eb2fd86e-0d6f-436a-86b6-3f20fdd37a0b_opag89.jpg",
      imageRotation: "rotate-0",
      hoverRotation: "group-hover:rotate-2",
    },

    {
      id: 10,
      category: "BLOGS",
      slug: "perfect-hack-boardroom-strategy", // Updated to match your new blog slug
      title:
        "The Mythos of the 'Perfect Hack': Why Your Boardroom Strategy Just Became Obsolete",
      description:
        "AI hasn't created new vulnerabilities; it just found the flashlight to expose the ones we've ignored for years.",
      cta: "Read Article",
      boxColor: "bg-[#0e7a5c]",
      titleColor: "text-white",
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/f_auto,q_auto,w_1200/v1777649809/perfect_hack_zvrhrv.png",
      imageRotation: "-rotate-2",
      hoverRotation: "group-hover:-rotate-6",
    },
    {
      id: 11,
      category: "WHITE PAPER",
      slug: "ai-guardrails-agentic-ai",
      title: "AI Guardrails",
      description:
        "As autonomous AI agents gain access to enterprise systems, APIs, and sensitive data, organizations need runtime guardrails, governance, and continuous oversight to prevent abuse, data leakage, and AI-driven compromise.",

      cta: "Download White Paper",
      boxColor: "bg-gray-900",
      titleColor: "text-white",
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/v1778574132/ai_guardrails_dojcvh.jpg",
      imageRotation: "rotate-1",
      hoverRotation: "group-hover:rotate-3",
    },
    {
      id: 12,
      category: "BLOGS",
      slug: "ztna-vs-vpn-future-of-secure-access",
      title: "ZTNA vs VPN: Why Zero Trust Is the Future of Secure Access",
      description:
        "ZTNA vs VPN is a critical comparison in today’s hyperconnected world, where remote workforces, cloud-driven data flows, and ever-evolving threats make securing enterprise network access more complex than ever.",
      cta: "Read Article",
      boxColor: "bg-[#0e7a5c]",
      titleColor: "text-white",
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/f_auto,q_auto,w_1200/v1780996162/ChatGPT_Image_Jun_9_2026_02_38_26_PM_rcqinr.png",
      imageRotation: "-rotate-2",
      hoverRotation: "group-hover:-rotate-6",
    },
    {
      id: 13, // Update this to your next sequential ID
      category: "BLOGS",
      slug: "browser-security-blind-spot",
      title: "The Browser Is Your Biggest Security Blind Spot",
      description:
        "95% of enterprises have been hit by browser-based attacks. Yet the browser remains the least governed control point in the enterprise. Here is what every CISO needs to understand.",
      cta: "Read Article",
      boxColor: "bg-[#0e7a5c]", // You can change this if you want a different card color
      titleColor: "text-white",
      coverImage:
        "https://res.cloudinary.com/dpn3bkjba/image/upload/q_auto/f_auto/v1783241813/browser_pkzygn.png",
      // Replace with your actual cover image URL for this blog

      imageRotation: "-rotate-2",
      hoverRotation: "group-hover:-rotate-6",
    },
  ];

  return (
    <ScrollReveal>
      <section className="w-full py-12 md:py-24 bg-[#032d28] font-sans overflow-hidden relative selection:bg-green-200 selection:text-green-900">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="flex items-center mb-8 md:mb-12">
            <h2 className="text-3xl md:text-5xl font-medium text-white whitespace-nowrap mr-4 md:mr-6 tracking-tight">
              Stay updated
            </h2>
            <div className="h-[1px] bg-white w-full opacity-70 mt-2 rounded-full"></div>
          </div>

          <div className="relative">
            <Swiper
              modules={[Navigation, Autoplay]}
              spaceBetween={20}
              slidesPerView={"auto"}
              loop={true}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              onAutoplayTimeLeft={onAutoplayTimeLeft}
              navigation={{
                prevEl: ".custom-prev-button",
                nextEl: ".custom-next-button",
              }}
              className="pb-12 !overflow-visible cursor-grab active:cursor-grabbing"
            >
              {resources.map((item) => (
                <SwiperSlide
                  key={item.id}
                  // 1. Ensure the slide itself attempts to take full height
                  className="!w-[280px] sm:!w-[350px] md:!w-[460px] !h-auto"
                >
                  {/* 2. Added 'h-full' to the container so all cards match the tallest one */}
                  <div className="bg-white rounded-[1.5rem] md:rounded-[2rem] p-6 md:p-8 shadow-xl flex flex-col h-full relative group transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl">
                    {/* 3. Fixed height for the title/image section ensures alignment */}
                    <div className="relative mb-6 md:mb-8 h-[180px] md:h-[220px] flex-shrink-0">
                      <div
                        className={`w-[75%] h-full rounded-2xl p-5 md:p-7 flex flex-col justify-center ${item.boxColor} transition-colors duration-300 overflow-hidden`}
                      >
                        <span
                          className={`text-[10px] md:text-[11px] font-extrabold tracking-widest mb-2 md:mb-4 uppercase ${item.titleColor} opacity-70`}
                        >
                          {item.category}
                        </span>
                        <h3
                          className={`text-xl md:text-2xl font-bold leading-tight ${item.titleColor} line-clamp-3`}
                        >
                          {item.title}
                        </h3>
                      </div>

                      <div
                        className={`absolute top-4 right-0 w-[110px] md:w-[130px] h-[150px] md:h-[180px] rounded-lg shadow-2xl overflow-hidden ${item.imageRotation} ${item.hoverRotation} origin-bottom-left transition-all duration-500 ease-out z-10 group-hover:scale-105 group-hover:shadow-[0_20px_50px_rgba(0,0,0,0.3)] bg-gray-100`}
                      >
                        <img
                          src={item.coverImage}
                          alt={item.title}
                          className="w-full h-full object-cover group-hover:scale-115 transition-transform duration-700"
                        />
                      </div>
                    </div>

                    {/* 4. 'flex-grow' on this container pushes the button to the bottom */}
                    <div className="flex-grow flex flex-col">
                      <p className="text-gray-600 text-sm md:text-[15px] leading-relaxed mb-6 md:mb-8 opacity-90 line-clamp-4">
                        {item.description}
                      </p>

                      {/* 5. 'mt-auto' ensures the button stays at the bottom regardless of text length */}
                      <button
                        onClick={() => {
                          const path =
                            item.category === "BLOGS"
                              ? `/blog/${item.slug}`
                              : `/resources/${item.slug}`;
                          navigate(path);
                        }}
                        className="mt-auto flex items-center text-[#008556] font-bold text-sm tracking-wide group/btn w-max"
                      >
                        {item.cta}
                        <span className="ml-2 bg-[#008556]/10 p-1 rounded-full transition-transform duration-300 group-hover/btn:translate-x-2 group-hover/btn:bg-[#008556] group-hover/btn:text-white">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2.5}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M9 5l7 7-7 7"
                            />
                          </svg>
                        </span>
                      </button>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Navigation Buttons */}
            <div className="flex gap-3 md:gap-4 mt-4 md:mt-8 items-center">
              <button
                aria-label="Previous slide"
                className="custom-prev-button group relative w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full border border-white/30 hover:bg-white transition-all duration-300"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-4 h-4 md:w-5 md:h-5 text-white group-hover:text-[#008556] transition-colors"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 19l-7-7 7-7"
                  />
                </svg>
              </button>

              <button
                aria-label="Next slide"
                className="custom-next-button group relative w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full cursor-pointer"
              >
                <svg
                  className="absolute w-full h-full rotate-[-90deg]"
                  viewBox="0 0 48 48"
                >
                  <circle
                    className="text-white/20"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="transparent"
                    r="22"
                    cx="24"
                    cy="24"
                  />
                  <circle
                    ref={progressCircle}
                    className="text-white transition-all duration-100 ease-linear"
                    strokeWidth="2"
                    strokeDasharray="138.2"
                    strokeDashoffset="calc(138.2 * var(--progress))"
                    strokeLinecap="round"
                    stroke="currentColor"
                    fill="transparent"
                    r="22"
                    cx="24"
                    cy="24"
                  />
                </svg>
                <div className="w-8 h-8 md:w-10 md:h-10 bg-white rounded-full flex items-center justify-center z-10 transition-transform duration-300 group-active:scale-90">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4 md:w-5 md:h-5 text-[#008556]"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2.5}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </button>
            </div>
          </div>
        </div>

        <style>{`
        .custom-next-button {
          --progress: 0;
        }
      `}</style>
      </section>
    </ScrollReveal>
  );
};

export default StayUpdated;
